import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { KanbanBoardStore } from '@store';

import { CommonStandaloneModule } from '../../../shared/common-standalone.module';
import { UIService } from '../../../shared/services/ui.service';

import { DashboardFilterInputComponent } from './dashboard-filter-input/dashboard-filter-input.component';
import { DashboardFilterListComponent } from './dashboard-filter-list/dashboard-filter-list.component';
import { Link, LinkID } from './kanban-installation-list-header.helper';
import { DashboardInstallationUrls } from '../../../+installations/installations-routing.helper';
import { RefreshSnapshotButtonComponent } from '../../../+dashboard/dashboard-view/refresh-snapshot-button/refresh-snapshot-button.component';
import { selectedKanbanPage } from '@store';

@Component({
  selector: 'app-kanban-installation-list-header',
  standalone: true,
  templateUrl: './kanban-installation-list-header.component.html',
  styleUrls: ['./kanban-installation-list-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonStandaloneModule,
    RouterModule,
    DashboardFilterInputComponent,
    DashboardFilterListComponent,
    RefreshSnapshotButtonComponent,
  ],
})
export class KanbanInstallationListHeaderComponent implements OnInit {
  @Input() isFilterListVisible = true;

  isMobileView: boolean;
  LinkID = LinkID;
  links: Link[];
  constructor(
    public kanbanBoardStore: KanbanBoardStore,
    private translateService: TranslateService,
    private uiService: UIService
  ) {}

  ngOnInit(): void {
    this.initLinks();
  }

  private initLinks(): void {
    const defaultLinks: Link[] = [
      {
        linkID: LinkID.list,
        link: '/' + DashboardInstallationUrls.List,
        label: this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.LIST'),
      },
      {
        linkID: LinkID.board,
        link: '/' + DashboardInstallationUrls.List + '/' + DashboardInstallationUrls.Board,
        label: this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.BOARD'),
      },
      {
        linkID: LinkID.map,
        link: '/installations/map',
        label: this.translateService.instant('+INSTALLATIONS.KANBAN_DASHBOARD.HEADER.MAP'),
      },
    ];

    this.isMobileView = this.uiService.isMobileView();

    if (this.isMobileView) {
      const linkListInMobileView: Link[] = defaultLinks.filter((link) => link.linkID !== 'board');
      this.links = linkListInMobileView;
    } else {
      this.links = defaultLinks;
    }
  }

  onTabSelection(link: string): void {
    localStorage.setItem(selectedKanbanPage, link);
  }
}
